import type { RouteObject } from 'react-router-dom'
import { Cart } from '@cart/views'

export const CartRouter: RouteObject[] = [
  {
    path: '/:slug/cart',
    element: <Cart />,
  },
]
